import { useMemo } from 'react'

import useRolePermission from '_hooks/use-role-permission'
import { ROUTES } from '_utils/constants'

export const INTERMEDIARY_READ_ONLY_ERROR_CODE = 'intermediary_help_request_read_only'

/** Fallback alinhado ao CustomAPIError.INTERMEDIARY_HELP_REQUEST_READ_ONLY do backend. */
export const INTERMEDIARY_READ_ONLY_MESSAGE = 'Este item está disponível apenas para visualização.'

export const INTERMEDIARY_READ_ONLY_ALERT_DESCRIPTION =
  'Este item está disponível apenas para consulta. Não é necessário nem permitido que você atue nele.'

export const INTERMEDIARY_READ_ONLY_EDIT_TOOLTIP =
  'Somente leitura. Você não tem permissão para editar este item.'

export const INTERMEDIARY_READ_ONLY_DELETE_TOOLTIP =
  'Somente leitura. Você não tem permissão para excluir este item.'

export const getTramitesPath = helpRequestId => `${ROUTES.HELP_REQUESTS}/tramites/${helpRequestId}`

const DEFAULT_API_ERROR_MESSAGE = 'Não foi possível executar esta ação, tente novamente.'

export const getApiErrorMessage = (error, fallback = DEFAULT_API_ERROR_MESSAGE) =>
  error?.error_message || error?.errorMessage || fallback

export const isIntermediaryReadOnlyApiError = error =>
  error?.error_code === INTERMEDIARY_READ_ONLY_ERROR_CODE ||
  error?.errorCode === INTERMEDIARY_READ_ONLY_ERROR_CODE

export const isHelpRequestReadOnlyForIntermediary = (
  helpRequest,
  { isIntermediary, isSAAS, isAdmin, noteType } = {}
) => {
  if (isAdmin || isSAAS || !isIntermediary) {
    return false
  }

  if (!helpRequest) {
    return false
  }

  // Anotações passam noteType; trâmites usam o HelpRequest carregado (typeSubject / intermediaryAvailable).
  if (noteType) {
    if (noteType !== 'HELP_REQUEST' && noteType !== 'JUSTIFIED_DELAY') {
      return false
    }
    if (noteType === 'JUSTIFIED_DELAY') {
      return true
    }
    return helpRequest.intermediaryAvailable !== true
  }

  if (helpRequest.typeSubject === 'justified_delayed') {
    return true
  }

  return helpRequest.intermediaryAvailable !== true
}

const useHelpRequestReadOnly = helpRequest => {
  const { isIntermediary, isSAAS, isAdmin } = useRolePermission()

  return useMemo(
    () =>
      isHelpRequestReadOnlyForIntermediary(helpRequest, {
        isIntermediary,
        isSAAS,
        isAdmin,
      }),
    [helpRequest, isIntermediary, isSAAS, isAdmin]
  )
}

export default useHelpRequestReadOnly
